"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safeQuery = void 0;
var _encodeQueryValue = require("./encodeQueryValue");
/* eslint-disable @typescript-eslint/naming-convention -- constant */

const unsafeChars = /[#&+=?]/g;
const safeReplacements = {
  '#': '%23',
  '&': '%26',
  '+': '%2B',
  '=': '%3D',
  '?': '%3F'
};
const safeKey = key => key.replaceAll(unsafeChars, match => safeReplacements[match] ?? '');
const safeQuery = search => {
  const query = {};
  for (const [key, value] of search) {
    query[safeKey(key)] = (0, _encodeQueryValue.encodeQueryValue)(value);
  }
  return query;
};
exports.safeQuery = safeQuery;
